import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router  } from 'react-router-dom'
import './index.css';

console.info(`msp-landing ${process.env.REACT_APP_VERSION_MAIN} (${process.env.REACT_APP_VERSION_DEV})`);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<Router><App /></Router>);